export default "__VITE_ASSET__DFZiKMpk__"